module.exports = __webpack_public_path__ + "img/ic_close.cc01859e.png";